import * as z from 'zod';
import { shopifyVariationFeedbackReasonSchema, shopifyStoredVariationFeedbackVoteSchema, } from './shopify-variation-feedback.js';
/** A local feedback form; only its complete value is sent when Submit is pressed. */
export const builderSuggestionFeedbackBlockSchema = z.strictObject({
    kind: z.literal('suggestion-feedback'),
    key: z.string().min(1),
    disabled: z.boolean(),
    savedVote: shopifyStoredVariationFeedbackVoteSchema.nullable(),
    savedReasonCodes: z.array(shopifyVariationFeedbackReasonSchema),
    savedComment: z.string().nullable(),
    labels: z.strictObject({
        up: z.string().min(1),
        down: z.string().min(1),
        title: z.string().min(1),
        responsePrompt: z.string().min(1),
        positiveReasonsPrompt: z.string().min(1),
        negativeReasonsPrompt: z.string().min(1),
        commentPrompt: z.string().min(1),
        submit: z.string().min(1),
        cancel: z.string().min(1),
        saved: z.string().min(1),
        reasonLimit: z.string().min(1),
        positiveReasons: z.array(z.strictObject({ code: shopifyVariationFeedbackReasonSchema, label: z.string().min(1) })),
        negativeReasons: z.array(z.strictObject({ code: shopifyVariationFeedbackReasonSchema, label: z.string().min(1) })),
    }),
});
//# sourceMappingURL=shopify-study-builder-suggestion-feedback-block.js.map